import { createFileRoute, redirect } from '@tanstack/react-router'

import { Flex } from '@masterplandev/ui'

import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import { FEATURE_TRANSFER_LICENSES_FORM } from '@/core/constants/features'
import useFeatures from '@/core/utils/features/useFeatures'
import { companyQueries } from '@/http/api/company'
import { usersQueries } from '@/http/api/users'
import { LicenseManager } from '@/users/components/LicensesManagement/LicenseManager'
import { LicensesForm } from '@/users/components/LicensesManagement/LicensesForm'

export const Route = createFileRoute(
  '/company/_management/users/$userId/licenses',
)({
  beforeLoad: async ({ context: { queryClient }, params: { userId } }) => {
    const [company, user] = await Promise.all([
      queryClient.ensureQueryData(companyQueries.detail()),
      queryClient.ensureQueryData(usersQueries.usersDetail(userId)),
    ])
    const canManageLicenses =
      user.roles.includes('manager') ||
      user.roles.includes('company_administrator')

    if (company.unlimited || !canManageLicenses) {
      throw redirect({
        to: '/company/users/$userId',
        params: { userId },
        search: true,
      })
    }
  },
  loader: ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(usersQueries.usersCurrentDetails())
  },
  component: RouteComponent,
  pendingComponent: LoadingIndicator,
})

function RouteComponent() {
  const hasTransferLicensesFormFeature = useFeatures(
    FEATURE_TRANSFER_LICENSES_FORM,
  )

  return (
    <Flex direction="column" h="100%" flexGrow={1} gap="6">
      {hasTransferLicensesFormFeature ? <LicensesForm /> : <LicenseManager />}
    </Flex>
  )
}
